import { h, createElement, Component } from "preact";


const cdn = "https://cdn.filestackcontent.com";


function imagePath(handle, format, width){
  return `${cdn}/compress/output=format:${format}/cache=expiry:max/resize=width:${width}/${handle}`
}

function buildSrcSet(handle, format, width){
  const sizes = [width/2, width, width*1.3]
  return sizes.map((size) => `${imagePath(handle, format, size)} ${size}w`).join(', ')
}

const Picture = ({ img, width = 1000, alt }) => {
  let handle = "VbieTVjAQvq5BTkE9vIi";
  if (img) {
    handle = img.handle;
  }
  const imageTypes = ['webp','png','jpg']
  return (
    <picture>
      {imageTypes.map((type) => <source
        srcset={buildSrcSet(handle, type, width)}
        type={`image/${type}`}
        sizes={`${width}w`}
      />)}
      <img
        src={`${imagePath(handle, 'jpg', width)}`}
        alt={alt}
        width={width}
        srcset={buildSrcSet(handle, 'jpg', width)}
      />
    </picture>
  );
};
export default Picture;
